module.exports = __webpack_public_path__ + "static/media/books-medical.d26491d0.svg";